export const aboutData = {
    title: "Who I am",
    description1: "My name's Marko. I'm a Full Stack and Blockchain developer based in Belgrade, Serbia.",
    description2: "I specialize in creating high-performance backend systems, intuitive frontends, and secure smartcontracts across Ethereum, Polygon, and BSC. My work spans DeFi platforms, NFT marketplaces, P2E games, and cross-chain solutions used by thousands of users. I'm passionate about clean code, fast delivery, and solving complex problems with innovative tech.",
    image: 2
}